import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import {
  InstitucionOpcionTerminalSnp,
  InstitucionSedeOpcionTerminalFormSnp,
  OpcionTerminalFormSnp,
  OpcionTerminalSnp,
} from '@/shared/model/snp/opcion-terminal.model';
import { BvTableFieldArray } from 'bootstrap-vue';

@Component
export default class OpcionesTerminalesListadoComponent extends ApeironComponent {
  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({
    required: false,
    default: function () {
      return new OpcionTerminalFormSnp();
    },
  })
  public opcionTerminalAgregar: OpcionTerminalFormSnp;

  public filtroOpcionesTerminales = '';
  public opcionesTerminalesFiltradas: Array<OpcionTerminalFormSnp> = [];
  public opcionesTerminales: Array<OpcionTerminalFormSnp> = [];

  public mostrarModalEliminar = false;

  public opcionTerminalSeleccionada: OpcionTerminalFormSnp = new OpcionTerminalFormSnp();

  public perPage = 15;
  public currentPage = 1;

  public readonly fieldsOpcionesTerminales: BvTableFieldArray = [
    {
      key: 'descripcionOpcionTerminal',
      label: this.$t('apeironGwApp.opcionterminalSnp.form.descripcionOpcionTerminal').toString(),
      class: 'text-left',
      thStyle: { width: '25rem' },
    },
    {
      key: 'instituciones',
      label: this.$t('apeironGwApp.opcionterminalSnp.form.institucion').toString(),
      class: 'text-left',
      thStyle: { width: '25rem' },
    },
    {
      key: 'fechaAlta',
      label: this.$t('apeironGwApp.opcionterminalSnp.form.fechaAlta').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'fechaBaja',
      label: this.$t('apeironGwApp.opcionterminalSnp.form.fechaBaja').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'acciones',
      label: this.$t('apeironGwApp.opcionterminalSnp.acciones.acciones').toString(),
      class: 'text-center btn-acciones',
      thStyle: { width: '8rem' },
      thClass: this.esEscritura ? '' : 'd-none',
      tdClass: this.esEscritura ? '' : 'd-none',
    },
  ];

  public mounted(): void {
    this.iniciarComponente();
  }

  @Watch('opcionTerminalAgregar')
  public watchOpcionTerminalAgregar(): void {
    if (this.opcionTerminalAgregar?.cveOpcionTerminal) {
      this.opcionesTerminales = this.opcionesTerminales.filter(
        opcionTerminal => opcionTerminal.cveOpcionTerminal !== this.opcionTerminalAgregar.cveOpcionTerminal
      );
    }
    this.opcionesTerminales.push(this.opcionTerminalAgregar);

    this.buscarEnOpcionesTerminales();
  }

  private iniciarComponente(): void {
    this.opcionTerminalSeleccionada = new OpcionTerminalFormSnp();

    this.mostrarModalEliminar = false;

    this.opcionesTerminales = [];

    (this.solicitud?.opcionesTerminales ?? []).forEach(currOpcionTerminalForm => {
      const instiucionesSede: Array<InstitucionSedeOpcionTerminalFormSnp> = [];

      (currOpcionTerminalForm.instituciones ?? []).forEach(currInst => {
        (currInst.sedes ?? []).forEach(currSede => {
          instiucionesSede.push({
            claveInstitucion: currInst.claveInstitucion,
            claveDependencia: currSede.claveDependencia,
            nombre: `${currInst.nombreInstitucion} || ${currSede.nombreDependencia} (${currSede.sede})`,
          });
        });
      });

      this.opcionesTerminales.push({
        cveOpcionTerminal: currOpcionTerminalForm.cveOpcionTerminal,
        descripcionOpcionTerminal: currOpcionTerminalForm.descripcionOpcionTerminal,
        fechaAlta: currOpcionTerminalForm.fechaAlta,
        fechaBaja: currOpcionTerminalForm.fechaBaja,
        instituciones: instiucionesSede,
      });
    });

    this.buscarEnOpcionesTerminales();
  }

  public mostrarModalEliminarOpcionTerminal(opcionTerminal: OpcionTerminalFormSnp): void {
    this.mostrarModalEliminar = true;
    this.opcionTerminalSeleccionada = opcionTerminal;
  }

  public eliminarOpcionTerminal(): void {
    this.opcionesTerminales = this.opcionesTerminales.filter(
      opcionTerminal => opcionTerminal.cveOpcionTerminal !== this.opcionTerminalSeleccionada.cveOpcionTerminal
    );
    this.mostrarModalEliminar = false;

    this.buscarEnOpcionesTerminales();
  }

  @Emit('editarOpcionTerminal')
  public editarOpcionTerminal(opcionTerminal: OpcionTerminalFormSnp): OpcionTerminalFormSnp {
    const opcionTerminalClonada = JSON.parse(JSON.stringify(opcionTerminal));

    this.buscarEnOpcionesTerminales();

    return opcionTerminalClonada;
  }

  public guardarOpcionesTerminales(): void {
    if (!this.readOnly) {
      const opcionesTerminalesGuardar: Array<OpcionTerminalSnp> = [];

      (this.opcionesTerminales ?? []).forEach(currOpcionTerminalForm => {
        const institucionesArbol: Array<InstitucionOpcionTerminalSnp> = [];

        (currOpcionTerminalForm.instituciones ?? []).forEach(currInstForm => {
          const institucionPrograma = (this.solicitud?.programa?.instituciones ?? []).find(
            institucion => institucion.claveInstitucion == currInstForm.claveInstitucion
          );
          let institucionArbol = institucionesArbol.find(institucion => institucion.claveInstitucion == currInstForm.claveInstitucion);

          if (!institucionArbol) {
            institucionArbol = {
              claveInstitucion: institucionPrograma.claveInstitucion,
              nombreInstitucion: institucionPrograma.nombreInstitucion,
              sedes: [],
            };

            institucionesArbol.push(institucionArbol);
          }

          const sedePrograma = (institucionPrograma.sedes ?? []).find(sede => sede.claveDependencia == currInstForm.claveDependencia);
          const sedeArbol = (institucionArbol.sedes ?? []).find(sede => sede.claveDependencia == currInstForm.claveDependencia);

          if (!sedeArbol) {
            institucionArbol.sedes.push({
              claveDependencia: sedePrograma.claveDependencia,
              claveSede: sedePrograma.claveSede,
              nombreDependencia: sedePrograma.nombreDependencia,
              sede: sedePrograma.sede,
            });
          }
        });

        opcionesTerminalesGuardar.push({
          cveOpcionTerminal: currOpcionTerminalForm.cveOpcionTerminal,
          descripcionOpcionTerminal: currOpcionTerminalForm.descripcionOpcionTerminal,
          fechaAlta: currOpcionTerminalForm.fechaAlta,
          fechaBaja: currOpcionTerminalForm.fechaBaja,
          instituciones: institucionesArbol,
        });
      });

      this.guardarSeccion(opcionesTerminalesGuardar);
    }
  }

  @Emit('guardarOpcionesTerminales')
  public guardarSeccion(opcionesTerminalesGuardar: Array<OpcionTerminalSnp>): Array<OpcionTerminalSnp> {
    return opcionesTerminalesGuardar;
  }

  public buscarEnOpcionesTerminales(): void {
    this.opcionesTerminalesFiltradas = [];

    this.opcionesTerminales.forEach(opcionTerminal => {
      if (this.filtroOpcionesTerminales) {
        if (opcionTerminal.descripcionOpcionTerminal?.toLowerCase().includes(this.filtroOpcionesTerminales.toLowerCase())) {
          this.opcionesTerminalesFiltradas.push(opcionTerminal);
        }
      } else {
        this.opcionesTerminalesFiltradas.push(opcionTerminal);
      }
    });
  }

  get registros(): number {
    return this.opcionesTerminalesFiltradas?.length ?? 0;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
